import {timezonesApi} from '@/api/timezones.api.js'
import {useErrorHandling} from '@/composables/use-error-handling.js'
import {ref, computed} from 'vue'

//Track timezones and loading flag
const timezones = ref([])
const isLoadingTimezones = ref(false)
const hasLoadedTimezones = computed(() => timezones.value.length > 0)
const loadingPromise = ref(null)

/**
 * Timezones composable
*/
export function useTimezones() {

  //Composables
  const {processError} = useErrorHandling()

  //Load timezones
  const loadTimezones = async () => {

    //Already loaded
    if (timezones.value.length > 0) {
      return
    }

    //Already loading
    if (loadingPromise.value) {
      return loadingPromise.value
    }

    //Create promise
    isLoadingTimezones.value = true
    loadingPromise.value = timezonesApi.query()

    //Load country codes
    try {
      const data = await loadingPromise.value
      timezones.value = data.timezones
    }
    catch (error) {
      processError(error)
      throw error
    }
    finally {
      isLoadingTimezones.value = false
      loadingPromise.value = null
    }
  }

  //Expose interface
  return {
    timezones,
    isLoadingTimezones,
    hasLoadedTimezones,
    loadTimezones,
  }
}
